function padZero(value) {
  return value.toString().padStart(2, '0')
}

export default function time(date) {
  if (date === undefined) return 'sem data'

  const newDate = date instanceof Date ? date : new Date(Number(date) * 1000)

  return `${padZero(newDate.getHours())}:${padZero(newDate.getMinutes())}`
}

/**
 * Get time in seconds and return time formatted 00:00
 * @param {*} timeInSeconds
 * @returns (string) 00:00
 */
export function formatAudioTime(timeInSeconds) {
  let mins = Math.floor(timeInSeconds / 60)
  if (mins < 10) {
    mins = '0' + String(mins)
  }
  let secs = Math.floor(timeInSeconds % 60)
  if (secs < 10) {
    secs = '0' + String(secs)
  }

  return mins + ':' + secs
}
